exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/mnt-master/master-menu/master-menu.component.css
// module id = ../../../../../src/app/mnt-master/master-menu/master-menu.component.css
// module chunks = main